// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3paK0","left":"InfoRow_left__MIL4R"};